<span *ngIf="hasFullContentReader" class="visually-hidden">{{ariaContent$$()}}</span>
<div class="container">
    <ng-container *ngFor="let item of breadcrumbIterable">
        <div *ngIf="item?.group; else standard" class="grouped-items">
            <ng-container *ngFor="let group of item.items">
                <ng-container *ngTemplateOutlet="createItems; context: { $implicit: group }"></ng-container>
            </ng-container>
        </div>
        <ng-template #standard>
            <ng-container *ngTemplateOutlet="createItems; context: { $implicit: item }"></ng-container>
        </ng-template>
    </ng-container>
</div>

<ng-template #createItems let-item>
    <finder-anchor
        *ngIf="item.link; else notLink"
        [ngClass]="item.class"
        [href]="trustUrl(item.link)">
        <span [innerHTML]="item.label | safeHtml"></span>
    </finder-anchor>
    <ng-template #notLink>
        <span *ngIf="item.label" [ngClass]="item.class" [innerHtml]="item.label | safeHtml"></span>
    </ng-template>
</ng-template>
